import { Globe } from 'lucide-react';
import { useId } from 'react';
import { Label } from './label';
import { Switch } from './switch';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './tooltip';

interface WebSearchToggleProps {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
}

export function WebSearchToggle({ enabled, onChange }: WebSearchToggleProps) {
  const id = useId();

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="flex shrink-0 items-center gap-2" data-web-search-toggle>
            <Label
              htmlFor={id}
              className="flex cursor-pointer items-center gap-1.5 text-xs text-slate-600"
            >
              <Globe className="h-3.5 w-3.5" />
              Web
            </Label>
            <Switch
              id={id}
              checked={enabled}
              onCheckedChange={onChange}
              size="compact"
              className="data-[state=checked]:bg-primary"
            />
          </div>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs">
          <p className="text-xs">
            Allows Case Partner to research public information on the web.
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
